export default __webpack_public_path__ + "static/Products-Ec-1ad4713f09b0b2a65d66cdf3c105eb0e.png";